(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function render(el, diff) {
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);
    var text = days > 0
      ? days + 'd ' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds)
      : pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    el.textContent = text;
  }

  function campaignEnd() {
    var phase = document.documentElement.getAttribute('data-az-campaign');
    if (phase !== 'before' && phase !== 'during') return NaN;
    var campaign = document.querySelector('[data-az-campaign][data-end]');
    return campaign ? Date.parse(campaign.getAttribute('data-end')) : NaN;
  }

  function hide(el) {
    var wrap = el.closest('[data-az-countdown-wrap]');
    if (wrap) {
      wrap.style.display = 'none';
    } else {
      el.textContent = '';
    }
  }

  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-az-countdown]').forEach(function (el) {
      var deadline = Date.parse(el.getAttribute('data-deadline') || '');
      if (isNaN(deadline)) deadline = campaignEnd();
      if (isNaN(deadline) || deadline - now <= 0) {
        hide(el);
        return;
      }
      render(el, deadline - now);
    });
  }

  tick();
  setInterval(tick, 1000);
})();
